import { Component, OnInit, Inject } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { Area } from '../../../shared/models/area.interface';
import { UntypedFormControl, NgForm } from '@angular/forms';
import { finalize, map, startWith } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from '../../models/generic.dialog.interface';
import { ItemMaster } from '../../../shared/models/item.master.interface';
import { ItemArea } from '../../../shared/models/item.area.interface';
import { AbstractBiditComponent } from '../../../shared/controls/abstract.bidit.component';
import { ItemFilter } from '../../models/item.filter';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';

export interface ItemMasterBindable extends ItemMaster {
  IsSelected: boolean;
}

@Component({
  selector: 'app-edit-area',
  templateUrl: './area.edit.component.html',
  styleUrls: ['./area.edit.component.scss']
})
export class AreaEditComponent extends AbstractBiditComponent implements OnInit {

  constructor(private adminService: AdminService, deviceDetectorService: DeviceDetectorService,
    public areaDialogRef: MatDialogRef<AreaEditComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) {
    super(deviceDetectorService);
  }

  accessoryControl = new UntypedFormControl();

  area: Area;
  areaAccessories: ItemArea[];
  selectedAreaAccessories: ItemMaster[] = [];

  errors: string;
  accessoryItems: ItemMasterBindable[];
  itemFilter: ItemFilter;

  accessorySelection: string;
  filteredAccessoryItems: Observable<ItemMasterBindable[]>;
  addAccessories: boolean = false;

  ngOnInit() {
    let areaId: number = this.data.id;
    let dealerId = this.adminService.getDealerId();
    this.itemFilter = {
      statusId: 1
    } as ItemFilter; // only show active items

    if (areaId == null) {
      this.area = {} as Area;
      this.area.area_IsActive = true;
    }
    else {
      this.adminService.getArea(areaId)
        .subscribe({
          next: (data) => {
            this.area = data;
            this.selectedAreaAccessories = data.itemAreas.map(ia => ia.item);

            this.selectedAreaAccessories.sort((a, b) => a.item_Name.localeCompare(b.item_Name));
          }
        })
    }

    this.filteredAccessoryItems = this.accessoryControl.valueChanges
      .pipe(
        startWith(''),
        map(value =>
          this._filter(value)
        )
    );

    this.adminService.searchItemList(this.itemFilter, dealerId)
      .subscribe({
        next: (data) => {
          this.accessoryItems = data.filter(i => i.itemType?.itemType_IsAccessory).map(i => i as ItemMasterBindable);
          this.accessoryControl.setValue('');
        }
      })
  }

  saveArea(form: NgForm) {
    console.log('in area onSubmit: ', this.area);

    this.errors = '';
    if (form.valid) {
      this.isRequesting = true;
      let dealerId = this.adminService.getDealerId();
      this.area.dealer_ID = dealerId;

      this.adminService.saveArea(this.area)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
            this.saveAreaAccessories(result);
          },
          error: (error: string) => {
            this.onError(error);
          },
          complete: () => {
            this.isRequesting = false;
          }
        });
    }
  }

  private _filter(value: string): ItemMasterBindable[] {
    if (this.accessoryItems == null) return new Array();

    const filterValue = value.toLowerCase();

    return this.accessoryItems.filter(acc => acc.item_Name.toLowerCase().indexOf(filterValue) !== -1);
  }

  showAddAccessory() {
    this.accessoryItems.forEach(i => {
      i.IsSelected = this.selectedAreaAccessories.find(sac => sac.item_ID == i.item_ID) != null;
    });

    this.addAccessories = !this.addAccessories;
  }

  finishAccessories() {
    this.accessoryControl.setValue('');

    this.accessoryItems.forEach(i => {
      if (i.IsSelected) this.addAccessory(i);
      else this.removeAccessory(i.item_ID);
    });


    this.selectedAreaAccessories.sort((a, b) => a.item_Name.localeCompare(b.item_Name));

    this.addAccessories = false;
  }

  addAccessory(item: ItemMaster) {
    let accessory = this.selectedAreaAccessories.find(acc => acc.item_ID == item.item_ID);    
    if (accessory == null) this.selectedAreaAccessories.push(item);
  }

  removeAccessory(itemId: number) {
    let accessory = this.selectedAreaAccessories.find(acc => acc.item_ID == itemId);
    if (accessory != null) {
      let index = this.selectedAreaAccessories.indexOf(accessory);
      this.selectedAreaAccessories.splice(index, 1);
    }
  }

  saveAreaAccessories(areaId: number) {
    console.log('in saveAreaAccessories - area: ' + areaId);
    this.errors = '';

    // if in the middle of adding, commit changes
    if (this.addAccessories)
      this.finishAccessories();

    this.adminService.saveAreaAccessories(areaId, this.selectedAreaAccessories.map(saa => saa.item_ID))
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe({
        next: (result) => {
          this.areaDialogRef.close(result);
        },
        error: (error: string) => {
          this.onError(error);
        },
        complete: () => {
          this.isRequesting = false;
        }
      });
  }

  onNoClick(): void {
    this.areaDialogRef.close();
  }

}
